import React, { useEffect, useState } from "react";
import { getAllMatchesAPI } from "../service/AuthService";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import moment from "moment";
import { useMutation, useQuery } from "react-query";
import { getClientBetsCricketAPI, handleBetAPI } from "../service/cricket";
import toast from "react-hot-toast";
import { Flex, Input, Select, Switch } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import PasswordCheckDeleteBets from "./components/PasswordCheckDeleteBets";

export default function MatchCurrentBets() {
  const [singleDeleteModal, setSingleDeleteModal] = useState(null);
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(0);
  const [isFancy, setIsFancy] = useState(false);
  const [betStatus, setBetStatus] = useState("MATCHED");
  const [search, setSearch] = useState("");
  const userData = useSelector((state) => state.account.userData);
  const [selectedSession, setSelectedSession] = useState("");
  const [bulkDelete, setBulkDelete] = useState([]);

  const id = useParams()

  console.log(id)
  const currentBets = useQuery(
    "currentBets",
    () =>
      getClientBetsCricketAPI(
        id?.id,
        isFancy,
        betStatus
      ),
    {
      refetchInterval: 2000,
    }
  );
  const totalLength =
    currentBets?.data?.response?.bets?.[0]?.upperLineExposure?.length;
  const uniqueRunnerNames = currentBets?.data?.response?.bets?.reduce(
    (acc, item) => {
      if (acc?.findIndex((_) => _.selectionName === item?.runnerName) === -1) {
        acc.push({ selectionName: item?.runnerName });
      }
      return acc;
    },
    []
  );
  const handleBet = async (data, action = "DELETED", id_ = false, password) => {
    const { response, code } = await handleBetAPI(id_ ? id_ : data.id, action, password);
    if (code === 200) {
      currentBets.refetch();
      setTimeout(() => {
        window.location.reload(true);
      }, 500); // 0.5 second delay
      toast.success("Bet Deleted Successfully");
    }
    else {
      toast.error(response || "Something went wrong");
    }
  };
  const bulkDeleteBets = async () => {
    for (let i = 0; i < bulkDelete.length; i++) {
      await handleBet({ id: bulkDelete[i] }, "DELETED");
    }
    currentBets.refetch();
    toast.success("Bets Deleted Successfully");
  };
  useEffect(() => { }, [bulkDelete]);
  return (
    <>
      {singleDeleteModal && (
        <PasswordCheckDeleteBets
          show={{
            matchId: id,
            handleBet: (password) => {
              handleBet(singleDeleteModal, "DELETED", false, password);
            },
          }}
          setShow={setSingleDeleteModal}
        />
      )}
      <div className="content-wrapper">
        <section className="content-header">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Bets For {location?.state?.matchDetails?.eventName} / Live Report</h3>

            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active">
                  <a href="/game/inPlay">Dashboard</a>
                </li>
              </ol>
            </div>
          </div>


          <div className="content">
          <div className="container-fluid">
          <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="col-lg-12">
                <div className="ibox float-e-margins">
                  {/* <div className="ibox-title">
                    <h5>All Bets</h5>
                    <div className="ibox-tools row" />
                  </div> */}
                  <Flex
                    flexDirection={{
                      base: "column",
                      md: "row",
                    }}
                    margin={5}
                  >
                    <Input
                      w={{ base: "100%", md: "30%" }}
                      type="text"
                      bg="white"
                      placeholder="Search (Username,Eventname)"
                      size="lg"
                      className="form-control input-lg"
                      onChange={(e) =>
                        e.target.value?.length > 3 && setSearch(e.target.value)
                      }
                    />
                    <Flex mx={5} alignItems="center">
                      <label htmlFor="fancy" mr={2}>
                        Fancy only
                      </label>
                      <Switch
                        mx={2}
                        size="lg"
                        id="fancy"
                        isChecked={isFancy}
                        onChange={() => setIsFancy(!isFancy)}
                      />
                      {isFancy && (
                        <Select
                          w={{ base: "100%", md: "60%" }}
                          placeholder="Select Session"
                          size="lg"
                          bg="white"
                          marginX={5}
                          className="form-control "
                          onChange={(e) => {
                            currentBets.refetch();
                            setSelectedSession(e.target.value);
                          }}
                        >
                          <option
                            onClick={() => {
                              currentBets.refetch();
                              setSelectedSession("");
                            }}
                            value={""}
                          >
                            All
                          </option>
                          {uniqueRunnerNames?.map((item, index) => (
                            <option value={item.selectionName}>
                              {item.selectionName}
                            </option>
                          ))}
                        </Select>
                      )}
                    </Flex>
                  </Flex>
                  <Flex
                    justifyContent={{
                      md: "flex-start",
                      base: "space-between",
                    }}
                  >
                    <button
                      style={{
                        marginRight: "10px",
                      }}
                      onClick={() => {
                        setBetStatus("MATCHED");
                        currentBets.refetch();
                      }}
                      className={`btn ${betStatus === "MATCHED" ? "btn-primary" : "btn-default"
                        }`}
                    >
                      <i className="fa fa-book" />
                      Matched Bets
                    </button>

                    <button
                      onClick={() => {
                        setBetStatus("DELETED");
                        currentBets.refetch();
                      }}
                      className={`btn ${betStatus === "DELETED" ? "btn-primary" : "btn-default"
                        }`}
                    >
                      <i className="fa fa-trash" /> Deleted Bets
                    </button>
                    {betStatus != "DELETED" && (
                      <button
                        style={{
                          marginLeft: "10px",
                        }}
                        onClick={bulkDeleteBets}
                        className="btn btn-danger"
                      >
                        <i
                          className="
                    fa fa-trash"
                          style={{ marginRight: "5px" }}
                        />
                        Bulk Delete
                      </button>
                    )}
                  </Flex>
                  <div class="ibox-content table-responsive ">
                    {isFancy ? (
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr className="tbl-header-middle">
                            <th colSpan={10}>Bet</th>
                            <th colSpan={3}>My Share / Position</th>
                            <th colSpan={2}>Settlement</th>
                          </tr>
                        </thead>
                        <thead>
                          <tr>
                            {betStatus != "DELETED" && (
                              <th>
                                <input
                                  onClick={(e) => {
                                    if (e.target.checked) {
                                      setBulkDelete(
                                        currentBets?.data?.response?.bets?.map(
                                          (item) => item.id
                                        )
                                      );
                                    } else {
                                      setBulkDelete([]);
                                    }
                                  }}
                                  className="bulk-delete"
                                  type="checkbox"
                                  name="betId"
                                />
                              </th>
                            )}
                            <th>Bet ID</th>
                            <th>DATE</th>
                            <th>User</th>
                            <th>Session Title</th>
                            <th>RATE</th>
                            <th>RUNS</th>
                            <th>AMOUNT</th>
                            <th>MODE</th>
                            <th>No</th>
                            <th>Yes</th>
                            <th>My Share</th>
                            <th>No</th>
                            <th>Yes</th>
                            <th>Status</th>
                            <th>Plus / Minus</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentBets?.data?.response?.bets
                            ?.filter((item) =>
                              item.runnerName?.includes(selectedSession)
                            )
                            ?.map((item) => (
                              <tr>
                                <td>
                                  <input
                                    onClick={
                                      betStatus != "DELETED"
                                        ? (e) => {
                                          if (e.target.checked) {
                                            setBulkDelete([
                                              ...bulkDelete,
                                              item.id,
                                            ]);
                                          } else {
                                            setBulkDelete(
                                              bulkDelete.filter(
                                                (id) => id !== item.id
                                              )
                                            );
                                          }
                                        }
                                        : () => { }
                                    }
                                    type="checkbox"
                                    checked={bulkDelete.find(
                                      (_) => _ === item.id
                                    )}
                                    name="betId"
                                  />
                                </td>
                                <td>{item?.id}</td>
                                <td>
                                  <i className="fa fa-clock-o" />
                                  &nbsp;
                                  {moment(item?.placeDate + "Z").format(
                                    "YYYY-MM-DD HH:mm:ss"
                                  )}
                                </td>
                                <td>{item?.userName}</td>
                                <td>{item?.marketName}</td>
                                <td>{item?.rate}</td>
                                <td>{item?.run}</td>
                                <td>{item?.amount}</td>
                                <td>{item?.back ? "YES" : "NO"}</td>
                                {item?.upperLineExposure?.map((_) => (
                                  <td>{_?.exposure}</td>
                                ))}
                                <td>{item?.myShare} %</td>
                                {item?.parentExposure?.map((_) => (
                                  <td>{_?.exposure}</td>
                                ))}
                                <td>
                                  <span
                                    className={`label ${item?.status
                                      ? "label-primary"
                                      : "label-secondary"
                                      }`}
                                  >
                                    {!item?.status ? "Not Settled" : "Settled"}
                                  </span>
                                </td>
                                <td>{item?.plusMinus}</td>
                                <td>
                                  <button
                                    onClick={() => setSingleDeleteModal(item)}
                                    className="btn btn-danger"
                                  >
                                    Delete
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th />
                            <th />
                            <th>Total</th>
                            <th />
                            <th />
                            <th />
                            <th>
                              {currentBets?.data?.response?.bets?.reduce(
                                (acc, item) => acc + item?.amount,
                                0
                              )}
                            </th>
                            <th />
                            {Array.from({ length: totalLength }).map(
                              (_, index) => (
                                <th>
                                  {currentBets?.data?.response?.bets?.reduce(
                                    (acc, item) =>
                                      acc +
                                      item?.upperLineExposure[index]?.exposure,
                                    0
                                  )}
                                </th>
                              )
                            )}

                            <th />
                            {Array.from({ length: totalLength }).map(
                              (_, index) => (
                                <th>
                                  {currentBets?.data?.response?.bets?.reduce(
                                    (acc, item) =>
                                      acc + item?.parentExposure[index]?.exposure,
                                    0
                                  )}
                                </th>
                              )
                            )}
                            <th />
                            <th>
                              {currentBets?.data?.response?.bets?.reduce(
                                (acc, item) => acc + item?.plusMinus,
                                0
                              )}
                            </th>
                          </tr>
                        </tfoot>
                      </table>
                    ) : (
                      <table class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th colspan="10">Bet</th>
                            <th colspan="3">My Share / Position</th>
                            <th colspan="2">Settlement</th>
                          </tr>
                        </thead>

                        <thead>
                          <tr>
                            <th>Bet ID</th>
                            <th>DATE</th>
                            <th>Market Title</th>
                            <th>RATE</th>
                            <th>AMOUNT</th>
                            <th>MODE</th>
                            <th>Runner Name</th>
                            <th>User</th>
                            {uniqueRunnerNames?.map((item, index) => (
                              <th>{item.selectionName}</th>
                            ))}
                            <th>My Share</th>
                            {uniqueRunnerNames?.map((item, index) => (
                              <th>{item.selectionName}</th>
                            ))}
                            <th>Status</th>
                            <th>Plus / Minus</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {currentBets?.data?.response?.bets?.map((item) => (
                            <tr>
                              <td>{item?.id}</td>
                              <td>
                                <i class="fa fa-clock-o" />
                                &nbsp;
                                {moment(item?.placeDate + "Z").format(
                                  "YYYY-MM-DD HH:mm:ss"
                                )}
                              </td>
                              <td>{item?.marketName}</td>
                              <td>{item?.rate}</td>
                              <td>{item?.amount}</td>
                              <td>
                                {!isFancy
                                  ? item?.back
                                    ? "LAGAI"
                                    : "KHAI"
                                  : item?.back
                                    ? "YES"
                                    : "NO"}
                              </td>
                              <td>{item?.runnerName}</td>
                              <td>{item?.userName}</td>

                              {item?.upperLineExposure?.map((_) => (
                                <th>{_?.exposure}</th>
                              ))}

                              <td>
                                {
                                  item?.myShare
                                }{" "}
                                %
                              </td>
                              {item?.parentExposure?.map((_) => (
                                <th className="runner-sum">{_?.exposure}</th>
                              ))}
                              <td>
                                <span
                                  class={`label ${item?.status
                                    ? "label-primary"
                                    : "label-secondary"
                                    }`}
                                >
                                  {!item?.status ? "Not Settled" : "Settled"}
                                </span>
                              </td>
                              <td>{item?.plusMinus}</td>
                              <td>
                                 <button
                                    onClick={() => setSingleDeleteModal(item)}
                                    className="btn btn-danger"
                                  >
                                    Delete
                                  </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th />
                            <th />
                            <th />
                            <th />
                            <th />
                            <th />
                            <th />
                            <th>Total</th>
                            {Array.from({ length: totalLength }).map(
                              (_, index) => (
                                <th>
                                  {currentBets?.data?.response?.bets?.reduce(
                                    (acc, item) =>
                                      acc +
                                      item?.upperLineExposure[index]?.exposure,
                                    0
                                  )}
                                </th>
                              )
                            )}

                            <th> </th>
                            {Array.from({ length: totalLength }).map(
                              (_, index) => (
                                <th>
                                  {currentBets?.data?.response?.bets?.reduce(
                                    (acc, item) =>
                                      acc + item?.parentExposure[index]?.exposure,
                                    0
                                  )}
                                </th>
                              )
                            )}
                            <th />
                            <th>
                              {currentBets?.data?.response?.bets?.reduce(
                                (acc, item) => acc + item?.plusMinus,
                                0
                              )}
                            </th>
                          </tr>
                        </tfoot>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          </div>
          </div>
        </section>
      </div>
    </>
  );
}
